// Fornecedores comuns às duas apps (dados, API, contas, línguas, dicas, notificações, imagens das cartas).
// O site e o backoffice arrancam exatamente da mesma maneira: só mudam os textos e a pele.
import { createApiClient } from "@ecliptica/api-client";
import { ApiProvider } from "@ecliptica/api-client/react";
import { I18nextProvider } from "@ecliptica/i18n";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { i18n as I18n } from "i18next";
import { lazy, Suspense, useState, type ReactNode } from "react";
import { CardAssetsProvider } from "./cards";

// O <Toaster> (onde aparecem as notificações) carrega à parte: não pesa no arranque das páginas.
const Toaster = lazy(() => import("@ecliptica/ui/toaster"));

export function PlatformProviders({
  i18n,
  apiUrl = typeof window !== "undefined" ? window.location.origin : "http://localhost:8790",
  cardsUrl = "/cards",
  children,
}: {
  i18n: I18n;
  apiUrl?: string;
  cardsUrl?: string;
  children: ReactNode;
}) {
  const [queryClient] = useState(() => new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } } }));
  const [api] = useState(() => createApiClient(apiUrl));
  return (
    <QueryClientProvider client={queryClient}>
      <ApiProvider client={api} authUrl={apiUrl}>
        <I18nextProvider i18n={i18n}>
          <CardAssetsProvider baseUrl={cardsUrl}>
            {children}
            <Suspense>
              <Toaster />
            </Suspense>
          </CardAssetsProvider>
        </I18nextProvider>
      </ApiProvider>
    </QueryClientProvider>
  );
}
